import { API } from '@/models/core'
import { FootballMatch } from '@/models/match'

export class FootballTournamentRound {
  static createFromJson (raw) {
    let matches = []
    raw.matches.forEach((matchRaw) => {
      matchRaw.teams = raw.teams
      // const match = FootballMatch.createFromJson({ match: matchRaw, teams: raw.teams })
      // matches.push(match)
      matches.push(FootballMatch.createFromJson(matchRaw))
    })
    raw.matches = matches
    let round = new FootballTournamentRound()
    round = Object.assign(round, raw)
    return round
  }
}

export class FootballTournamentPointsTable {
  static createFromJson (raw) {
    let table = new FootballTournamentPointsTable()
    table = Object.assign(table, raw)
    return table
  }
}

export class FootballTournamentStats {
  static createFromJson (raw) {
    let stats = new FootballTournamentStats()
    stats = Object.assign(stats, raw)
    return stats
  }
}

export class FootballTournamentTeam {
  static createFromJson (raw) {
    let team = new FootballTournamentTeam()
    team = Object.assign(team, raw)
    return team
  }
}

export class FootballTournamentTeamStats {
  static createFromJson (raw) {
    let stats = new FootballTournamentTeamStats()
    stats = Object.assign(stats, raw)
    return stats
  }
}

export class FootballTournamentPlayerStats {
  static createFromJson (raw) {
    let stats = new FootballTournamentPlayerStats()
    stats = Object.assign(stats, raw)
    return stats
  }
}

export class FootballTournament {
  static createFromJson (raw) {
    let tournament = new FootballTournament()
    tournament = Object.assign(tournament, raw)
    return tournament
  }

  static fetch (key) {
    return API.instance().get(`/tournament/${key}/`).then((resp) => {
      const raw = resp.data.data
      const tournament = FootballTournament.createFromJson(raw.tournament)
      tournament.pointsTable = FootballTournamentPointsTable.createFromJson(raw.points_table)
      tournament.stats = FootballTournamentStats.createFromJson(raw.stats)
      return tournament
    })
  }

  static fetchRound (key, roundkey) {
    return API.instance().get(`/tournament/${key}/round/${roundkey}/`).then((resp) => {
      const raw = resp.data.data.round
      return FootballTournamentRound.createFromJson(raw)
    })
  }

  static fetchTeam (key, teamkey) {
    return API.instance().get(`/tournament/${key}/team/${teamkey}/`).then((resp) => {
      const raw = resp.data.data
      const team = FootballTournamentTeam.createFromJson(raw.team)
      const stats = FootballTournamentPlayerStats.createFromJson(raw.stats)
      return { team, stats }
    })
  }

  static fetchPlayer (key, roundkey) {
    return API.instance().get(`/tournament/${key}/player/${roundkey}/`).then((resp) => {
      const raw = resp.data.data.stats
      return FootballTournamentPlayerStats.createFromJson(raw)
    })
  }

  static recent (key) {
    return API.instance().get(`/recent-tournaments/`).then((resp) => {
      const raw = resp.data.data.tournaments
      let tournaments = []
      raw.forEach((rawTournament) => {
        tournaments.push(FootballTournament.createFromJson(rawTournament))
      })
      return tournaments
    })
  }
}
